// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M4.82 7.65 L6.8 5.67 C8.49 3.97 10.31 3.11 12.16 3.09 C12.6 3.08 12.92 3.4 12.91 3.84 C12.89 5.69 12.03 7.51 10.33 9.2 L8.35 11.18 Z',
  'M6.8 5.67 C5.53 5.05 4.03 5.25 3.04 6.25 L2.24 7.05 C1.96 7.32 2.05 7.75 2.44 7.82 L4.29 8.18 L4.82 7.65',
  'M10.33 9.2 C10.95 10.47 10.75 11.97 9.75 12.96 L8.95 13.76 C8.68 14.04 8.25 13.95 8.18 13.56 L7.82 11.71 L8.35 11.18',
  'M5.17 10.83 C5.66 11.32 5.63 12.07 5.14 12.55 C4.55 13.15 3.49 13.23 3.02 13.23 C2.88 13.23 2.77 13.12 2.77 12.98 C2.77 12.51 2.85 11.45 3.45 10.86 C3.93 10.37 4.68 10.34 5.17 10.83 Z',
];
